module.exports = __webpack_public_path__ + "assets/74b827790f7eb1e9584a4886e391ccc2.mp3";